

















import '../../styles/common-modal.css'
import Modal from './modal/Modal.vue'
import ModalBody from './modal/ModalBody.vue'
import Vue from 'vue'

export default Vue.extend({
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
  },
  components: { Modal, ModalBody },
  name: 'OkModal',
})
